import { Environment } from '@/@types/environment';
import { EntitlementType } from '@/@types/entitlement';
import { APP_CONFIG } from '@/config';
import { put } from '../request';

export const addAdacEntitlement = async () => {
  if (APP_CONFIG.environment !== Environment.SANDBOX && process.env.NODE_ENV !== 'development') {
    throw new Error('Only available on BOX or locally.');
  }

  return put(`${APP_CONFIG.entitlementApiUrl}/internal/entitlements/my`, [
    {
      externalId: crypto.randomUUID(),
      serviceType: EntitlementType.ADAC_WP,
      serviceStartDate: new Date().toISOString().slice(0, 10),
      entitlementStatus: 'CREATED',
    },
  ]);
};
